import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ListItem, Responsible } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

@Component({
    name: 'ResponsibleModal',
    components: {}
})
export default class ResponsibleModal extends Vue {
    @Prop({ required: true })
    readonly state!: KanbanState;
    @Prop({ required: true })
    readonly responsibles!: Responsible[];

    //runtime
    private filter: string = '';

    public open(): void {
        $(this.$refs.modal!).modal('show');
        this.filter = '';
    }

    public dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private get available(): ListItem[] {
        let ex = this.responsibles.map(e => e.userId);
        return this.state.users.filter(e => !ex.includes(e.id));
    }

    private get responsiblesFiltered(): Responsible[] {
        return this.responsibles
            .filter(r => !this.filter?.trim().length || (r.user!.firstName + ' ' + r.user!.lastName).toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
            .sort((a, b) => (a.user!.lastName + ' ' + a.user!.firstName).toLocaleLowerCase().localeCompare((b.user!.lastName + ' ' + b.user!.firstName).toLocaleLowerCase()));
    }

    private get availableFiltered(): ListItem[] {
        return this.available
            .filter(u => !this.filter?.trim().length || (u.firstName + ' ' + u.lastName).toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
            .sort((a, b) => (a.lastName + ' ' + a.firstName).toLocaleLowerCase().localeCompare((b.lastName + ' ' + b.firstName).toLocaleLowerCase()));
    }

    private close(): void {

    }

    private add(user: ListItem): void {
        this.$emit('addResponsible', user);
    }

    private remove(responsible: Responsible): void {
        this.$emit('removeResponsible', responsible);
    }
}